module.exports = __webpack_public_path__ + "img/chapter__8_image_2.6cefcb93.jpg";